import { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaHover } from 'themes/mixins/mediaHover';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

const motives = {
  m0: null,
  default: css`
    letter-spacing: 0.1rem;

    ${mediaHover(css`
      color: ${pickColor('red')};
    `)}
  `,
  actionPrimary: css`
    padding: 0 4rem;

    background-color: ${pickColor('colmarBlue')};
    color: ${pickColor('white')};
    border-radius: ${({ theme }) => theme.borderRadius.base};

    ${mediaHover(css`
      background-color: ${pickColor('colmarRed')};
    `)}
  `,
  actionSecondary: css`
    padding: 0.6rem 1.4rem;

    background-color: ${pickColor('green')};
    border-radius: ${({ theme }) => theme.borderRadius.big};
    color: ${pickColor('white')};

    ${mediaHover(css`
      background-color: ${pickColor('greenDark')};
    `)}
  `,
  actionTertiary: css`
    padding: 0.6rem 1.4rem;

    border-radius: ${({ theme }) => theme.borderRadius.big};
    background-color: ${pickColor('blue')};
    color: ${pickColor('white')};

    ${mediaHover(css`
      background-color: ${pickColor('blueDark')};
    `)}
  `,
  actionQuaternary: css`
    gap: 1.2rem;

    height: 4.6rem;
    padding: 0 2.6rem;

    border: 0.2rem solid ${pickColor('title')};
    border-radius: ${({ theme }) => theme.borderRadius.base};
    color: ${pickColor('title')};

    ${mediaHover(css`
      background-color: ${pickColor('title')};
      color: ${pickColor('white')};
    `)}
  `,
  cancelPrimary: css`
    padding: 0.6rem 1.4rem;

    background-color: ${pickColor('red')};
    border-radius: ${({ theme }) => theme.borderRadius.big};
    color: ${pickColor('white')};

    ${mediaHover(css`
      background-color: ${pickColor('redSecondary')};
    `)}
  `,
  cancelSecondary: css`
    padding: 0 4rem;

    background-color: ${pickColor('blueFilter')};
    color: ${pickColor('colmarBlue')};
    border-radius: ${({ theme }) => theme.borderRadius.base};

    ${mediaHover(css`
      background-color: ${pickColor('black')};
      color: ${pickColor('white')};
    `)}
  `,
  cancelTertiary: css`
    padding: 0 4rem;

    background-color: transparent;
    color: ${pickColor('black')};
    border: 0.1rem solid ${pickColor('borderLight')};
    border-radius: ${({ theme }) => theme.borderRadius.base};

    ${mediaHover(css`
      background-color: ${pickColor('borderLight')};
    `)}
  `,
  submitPrimary: css`
    justify-content: center;

    min-height: 4.5rem;
    padding: 1.15rem 0;

    background-color: ${pickColor('black')};
    color: ${pickColor('white')};
    border-radius: ${({ theme }) => theme.borderRadius.base};

    ${mediaHover(css`
      background-color: ${pickColor('darkRed')};
    `)}
  `,
  settings: css`
    padding: 0 1.2rem;
    width: 100%;

    color: ${pickColor('white')};

    ${mediaHover(css`
      background-color: ${pickColor('blackLight')};
    `)}
  `,
  inlineRed: css`
    color: ${pickColor('darkRed')};

    ${mediaHover(css`
      color: ${pickColor('black')};
    `)}
  `,
  inlineGray: css`
    color: ${pickColor('title')};

    border-bottom: 0.1rem dotted ${pickColor('title')};

    ${mediaHover(css`
      color: ${pickColor('grayDark')};

      border-bottom: 0.1rem dotted ${pickColor('grayDark')};
    `)}
  `,
  inlineUnderline: css`
    padding: 0 1.2rem;

    text-decoration: underline;

    color: ${pickColor('white')};
  `,
  navigation: css`
    padding: 1.2rem 0;

    color: ${pickColor('white')};

    letter-spacing: 0.1rem;
  `,
  navigationSecondary: css`
    padding: 1.2rem;

    border-left: 0.2rem solid ${pickColor('red')};
    color: ${pickColor('white')};
  `,
  carouselNavigationPrimary: css`
    display: flex;
    justify-content: center;
    align-items: center;

    height: 5rem;
    width: 3.4rem;

    background-color: ${pickColor('white')};
    box-shadow: 0 0.3rem 2.4rem -1rem ${pickColor('shadow')};

    ${mediaHover(css`
      color: ${pickColor('blue')};
    `)};
  `,
  carouselNavigationSecondary: css`
    display: flex;
    justify-content: center;
    align-items: center;

    height: 5.2rem;
    width: 5.2rem;

    background-color: ${pickColor('blackTransparent')};

    ${mediaHover(css`
      background-color: ${pickColor('blackTransparentSecondary')};
    `)};
  `,
  back: css`
    ${mediaHover(css`
      color: ${pickColor('blue')};
    `)};

    svg {
      stroke-width: 2;
    }
  `,
  backSecondary: css`
    svg {
      stroke-width: 2;
    }

    ${mediaHover(css`
      color: ${pickColor('darkRed')};
    `)};
  `,
  addPrimary: css`
    padding: 0.6rem 1.4rem;

    background-color: ${pickColor('colmarRed')};
    border-radius: ${({ theme }) => theme.borderRadius.base};
    color: ${pickColor('white')};

    ${mediaHover(css`
      background-color: ${pickColor('darkRedSecondary')};
    `)}
  `,
  addSecondary: css`
    justify-content: center;

    ${mediaHover(css`
      color: ${pickColor('white')};
      background-color: ${pickColor('black')};
    `)}
  `,
  slidePage: css`
    padding: 0.5rem 1rem;
    min-width: 3.2rem;

    color: ${pickColor('black')};
    border: 0.1rem solid ${pickColor('black')};
    border-radius: ${({ theme }) => theme.borderRadius.base};

    ${mediaHover(css`
      color: ${pickColor('white')};
      background-color: ${pickColor('colmarBlue')};
      border-color: ${pickColor('colmarBlue')};
    `)}
  `,
  dropdownMenu: css`
    color: ${pickColor('white')};

    ${mediaHover(css`
      background-color: ${pickColor('white')};
      color: ${pickColor('red')};
    `)}
  `,
  menuLink: css`
    padding: 0 1.5rem;
    ${mediaMinWidth.lg(css`
      padding: 1rem 1.5rem;
    `)}
  `,
  deleteIcon: css`
    color: ${pickColor('red')};

    ${mediaHover(css`
      color: ${pickColor('white')};
    `)}
  `,
  // Ported from colmar-admin-catalogue-fe's identical motive (02.09.2026:
  // requested to make it match the admin panel one-to-one) — this is the
  // first table-row delete button in catalogue-fe, so there was
  // no existing local convention to match instead. Uses `redSecondary`
  // (#c7254e) rather than `red` (#ff0000, pure/saturated) — this app's `red`
  // token is a much brighter shade than admin-fe's own `red` (#c9424b);
  // `redSecondary` is the close match (reported live: the red shouldn't be
  // so bright).
  tableActionDelete: css`
    justify-content: center;
    align-items: center;

    width: 3rem;
    height: 3rem;
    padding: 0;

    background-color: transparent;
    color: ${pickColor('black')};
    border: 0.1rem solid ${pickColor('borderColorDark')};
    border-radius: ${({ theme }) => theme.borderRadius.base};

    ${mediaHover(css`
      color: ${pickColor('redSecondary')};
      border-color: ${pickColor('redSecondary')};
    `)}
  `,
  edit: css`
    padding: 0.6rem 1.4rem;

    border-radius: ${({ theme }) => theme.borderRadius.base};
    background-color: ${pickColor('black')};
    color: ${pickColor('white')};

    ${mediaHover(css`
      background-color: ${pickColor('borderColorDarkSecondary')};
    `)}
  `,
  send: css`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 3.6rem;
    height: 3.6rem;

    background-color: ${pickColor('colmarBlue')};
    color: ${pickColor('white')};
    border-radius: 50%;

    span {
      font-size: 2.4rem;
    }
  `,
  white: css`
    color: ${pickColor('white')};

    span {
      font-size: 2.1rem;
    }
  `,
  whiteSecondary: css`
    height: auto;
    margin-bottom: 0.6rem;
    color: ${pickColor('white')};

    ${mediaHover(css`
      text-decoration: underline;
    `)}
  `,
  linkPrimary: css`
    justify-content: center;

    letter-spacing: 0.1rem;

    ${mediaHover(css`
      color: ${pickColor('red')};
    `)}
  `,
  linkSecondary: css`
    align-items: flex-start;

    color: ${pickColor('grayDarkSecondary')};

    ${mediaHover(css`
      color: ${pickColor('red')};
    `)}
  `,
  tableHeaderPrimary: css`
    align-items: flex-end;

    color: ${pickColor('red')};
  `,
  transparentPrimary: css`
    background-color: ${pickColor('blackTransparent')};
    border-radius: ${({ theme }) => theme.borderRadius.base};
    color: ${pickColor('white')};

    ${mediaHover(css`
      background-color: ${pickColor('red')};
    `)}
  `,
  productTitle: css`
    height: auto;
    justify-content: center;

    white-space: pre-line;
    word-break: break-word;

    letter-spacing: 0.1rem;

    ${mediaHover(css`
      color: ${pickColor('red')};
    `)}
  `,
  slideIconPrimary: css`
    position: relative;
    overflow: hidden;

    height: 2.9rem;

    border-radius: ${({ theme }) => theme.borderRadius.base};

    background-color: ${pickColor('greenLightSecondary')};
    color: ${pickColor('white')};

    letter-spacing: 0.1rem;

    text-shadow: 0.1rem 0.1rem 0.1rem rgba(0, 0, 0, 0.2);

    ${mediaHover(css`
      .icon-left {
        left: 0;
      }
    `)}

    .icon-left {
      position: absolute;
      top: 0;
      left: -1.8rem;

      height: 100%;
      padding: 0 0.4rem;

      background-color: rgba(0, 0, 0, 0.1);

      transition: left 200ms linear;
    }
  `,
  actionRed: css`
    padding: 0 1.4rem;

    background-color: ${pickColor('red')};
    color: ${pickColor('white')};

    ${mediaHover(css`
      background-color: ${pickColor('title')};
      text-shadow: 0.1rem 0.1rem 0.1rem rgb(0 0 0 / 20%);
    `)}
  `,
  grayPrimary: css`
    padding: 2.4rem 0;
    background-color: ${pickColor('buttonGray')};
    color: ${pickColor('grayDark')};
    border-radius: ${({ theme }) => theme.borderRadius.base};

    ${mediaHover(css`
      background-color: ${pickColor('title')};
      text-shadow: 0.1rem 0.1rem 0.1rem rgb(0 0 0 / 20%);
      color: ${pickColor('white')};
    `)}
  `,
  iconColumn: css`
    flex-direction: column;
    gap: 1.2rem;
    height: auto;

    padding: 1.2rem;

    border-right: 0.1rem solid ${pickColor('borderExtraLight')};

    ${mediaHover(css`
      color: ${pickColor('white')};
      background-color: ${pickColor('blackLight')};
    `)}
  `,
  redUnderline: css`
    color: ${pickColor('red')};

    border-bottom: 0.1rem solid ${pickColor('red')};

    font-style: italic;
    letter-spacing: 0.1rem;

    ${mediaHover(css`
      color: ${pickColor('black')};
      border-color: ${pickColor('black')};
    `)}
  `,
};

export type ButtonMotives = keyof typeof motives;

const pickMotive = (motive: ButtonMotives) => motives[motive];

export { pickMotive };
